<template>

<v-container grid-list-xs,sm,md,lg,xl>
<h1> Please choose game </h1>
<v-card class="mx-auto"
max-width="344"
outline
v-on:click="showUserPicker()">
<v-card-title primary-title >

  <!-- Following https://codepen.io/pen/?&editable=true&editors=101 -->
<v-layout justify-center>

  <h2>Mathemanics</h2>
</v-layout>
</v-card-title>
<UserPicker :clicks="this.clicks" @childEvent="onChildClicked()"/>
<v-list-item three-line>

<p>

    Fill the spacecraft in order to acheive liftoff!
</p>



</v-list-item>
</v-card>
</v-container>
</template>
<script>
import UserPicker from "../components/UserPicker";
export default{
name:"GamesPage",
components:{
  UserPicker
},
  data(){
    return{
userpicker:false,
clicks:false,
    }
  },
  methods:{
    showUserPicker(){
      this.clicks=true;
    
    },
    onChildClicked(value){

      this.clicks=false;
      console.log("Changed parent to "+this.clicks)
    }
  }
}
    /* eslint-disable */
</script>
